import React, { useCallback, useContext, useEffect, useState } from 'react';
import style from './style';
import clsx from 'clsx';
import EAIcon from '../../../EAIcon';
import i18next from 'i18next';
import EAButton from '../../../EAButton';
import Attribute from '../../../../../containers/Context/AddContext/steps/ContextAttributes/Attribute';
import { Context } from '../../../../../states/Store';
import { IconButton } from '@mui/material';
import {
  archiveThirdParty,
  getContextInstanceThirdPartyAttributes,
} from '../../../../../services/edge/ContexteService';
import ROUTES from '../../../../../config/Routes';
import {
  PrivilegeEnum,
  RoleBasedAccessControlContext,
} from '../../../../../services/common/RolesUtils';
import { FormProvider, useForm } from 'react-hook-form';
import ArchiveDialog from '../../../../../containers/Context/ArchiveDialog';
import EAColorIcon from '../../../EAColorIcon';
const FORM_ID = 'archive_tp_form'

const NodeTemplate = ({
  node,
  currentSelectedNodeId,
  addTp,
  thirdParty,
  fetchAssociatedTP,
  isDragging,
}) => {
  const { classes } = style();
  const [state, dispatch] = useContext(Context);
  const isSelected = node.identifiant === currentSelectedNodeId;
  const [showTiersAttributes, setShowTiersAttributes] = useState(false);
  const [showDemandeAttributes, setShowDemandeAttributes] = useState(false);
  const isRoot = node.identifiant === 'root';
  const [tiersAttributes, setTiersAttributes] = useState(null);
  const [demandeAttributes, setDemandeAttributes] = useState(null);
  const [isArchiveOpen, setIsArchiveOpen] = useState(false);
  const [tpIdToArchive, setTpIdToArchive] = useState(null);

  const { hasAnyOfPrivileges } = useContext(RoleBasedAccessControlContext);

  const methods = useForm({
    mode: 'onChange',
    delayError: 500,
    defaultValues: {
      motif: '',
    },
  });

  const onEditAttribute = () => {
    fetchAssociatedTP();
  };

  const getNodeOriginClass = () => {
    if (node.origin === 'CLIENT' && node.parentId !== -1) {
      return classes.originClient;
    } else if (node.origin === 'THIRDPARTY') {
      return classes.originThirdParty;
    } else if (node.origin === 'CLIENT_AND_THIRDPARTY') {
      return classes.originClientAndThirdParty;
    }
  };

  useEffect(() => {
    if (isSelected) {
      dispatch({
        type: 'SELECTED_CONTEXT_THIRDPARTY',
        contextThirdParty: thirdParty,
      });
      const fetchAttributes = async () => {
        const tpAttributes = await getContextInstanceThirdPartyAttributes(
          state.account.id,
          thirdParty.id,
          thirdParty.ctxInstanceId
        );
        const { tiersAttributes, demandeAttributes } = tpAttributes;
        setTiersAttributes(tiersAttributes);
        setDemandeAttributes(demandeAttributes);
      };
      if (node.identifiant !== 'root') {
        fetchAttributes();
      }
    }
  }, [isSelected, thirdParty, dispatch, node.identifiant, state.account.id]);

  const deleteTp = async (tpId) => {
    setTpIdToArchive(tpId);
    setIsArchiveOpen(true);
  };

  const archiveTiersCallback = useCallback(async (data) => {
    await archiveThirdParty(
      state.account.id,
      tpIdToArchive,
      data,
      dispatch
    );
    await fetchAssociatedTP();
  },[tpIdToArchive, state.account.id, fetchAssociatedTP, dispatch])

  const displayTiers = () => {
    window.open(
      `/${state.account.id}/${ROUTES.CONTEXT}?instance=${thirdParty.ctxInstanceId}&thirdparty=${thirdParty.id}`,
      '_blank'
    );
  };

  return (<>
    <div>
      <div
        className={clsx(
          classes.node,
          getNodeOriginClass(),
          isSelected && !isRoot ? classes.selectedNode : '',
          node.isArchived ? classes.isArchived : '',
        )}
      >
        {!isRoot && isSelected && (
          <div className={classes.attachedNodePoint}></div>
        )}
        {!isRoot && !node.isContextArchived && !node.isArchived &&
          hasAnyOfPrivileges(PrivilegeEnum.PRIVILEGE_ARCHIVE_CONTEXT) && (
            <IconButton
              onClick={() => !isDragging && deleteTp(thirdParty.id)}
              size="small"
              style={{ position: 'absolute', right: '-30px' }}
            >
              <EAIcon
                className={classes.deleteIcon}
                icon={'delete_filled'}
                draggable={false}
              />
            </IconButton>
          )}
        <div className={classes.nodeInfosWrapper}>
          {node.icon && (
            <EAColorIcon
              icon={
                isSelected ? '/context/contextTree/selectedTiers' : node.icon
              }
              draggable={false}
            />
          )}
          <div className={classes.nodeInfos}>
            <div
              className={classes.nodeTitle}
              id={isRoot ? 'treeRoot' : node.identifiant}
            >
              {node.label}
            </div>
            {!isRoot && (
              <div
                className={classes.moreDetails}
                onClick={() =>
                  !isDragging && displayTiers(thirdParty.compteFoId)
                }
              >
                <EAIcon
                  icon={'context/contextTree/moreDetails'}
                  draggable={false}
                />
                <span>{i18next.t('moreDetails')}</span>
              </div>
            )}
          </div>
          {node.isArchived&&<EAIcon className={classes.archivedIcon} icon={"context/archiveItem2"} draggable={false}/>}
        </div>
      </div>
      {!isRoot && isSelected && (
        <div className={classes.nodeAttributes}>
          {tiersAttributes && tiersAttributes.length ? (
            <div className={classes.nodeAttributeListWrapper}>
              <div
                className={classes.nodeAttributeDropDown}
                onClick={() => setShowTiersAttributes(!showTiersAttributes)}
              >
                <EAIcon
                  className={showTiersAttributes ? classes.openAttributes : ''}
                  icon={'context/contextTree/arrowRight'}
                  draggable={false}
                />
                <span>{i18next.t('context.addTiers.attributsAuTiers')}</span>
              </div>
              {showTiersAttributes && (
                <div className={classes.nodeAttributeList}>
                  {tiersAttributes.map((tiersAttribute, i) => (
                    <div key={tiersAttribute.attributeId}>
                      <Attribute
                        contexteAttribute={tiersAttribute}
                        onValidateSuccess={onEditAttribute}
                        currentValue={tiersAttributes.find(
                          (c) => c.label === tiersAttribute.label
                        )}
                        variant={'contextGraph'}
                        attributeIndex={i}
                        disabled={
                          node.isContextArchived || node.isArchived ||
                          !hasAnyOfPrivileges(
                            PrivilegeEnum.PRIVILEGE_EDIT_CONTEXT_THIRD_PARTY_ATTRIBUTES
                          )
                        }
                      />
                    </div>
                  ))}
                </div>
              )}
            </div>
          ) : (
            <></>
          )}
          {demandeAttributes && demandeAttributes.length ? (
            <div className={classes.nodeAttributeListWrapper}>
              <div
                className={classes.nodeAttributeDropDown}
                onClick={() => setShowDemandeAttributes(!showDemandeAttributes)}
              >
                <EAIcon
                  className={
                    showDemandeAttributes ? classes.openAttributes : ''
                  }
                  icon={'context/contextTree/arrowRight'}
                  draggable={false}
                />
                <span>
                  {i18next.t('context.addTiers.attributsAuDeclarant')}
                </span>
              </div>
              {showDemandeAttributes && (
                <div className={classes.nodeAttributeList}>
                  {demandeAttributes.map((demandeAttribute, i) => (
                    <div key={demandeAttribute.attributeId}>
                      <Attribute
                        contexteAttribute={demandeAttribute}
                        onValidateSuccess={onEditAttribute}
                        currentValue={demandeAttributes.find(
                          (c) => c.label === demandeAttribute.label
                        )}
                        variant={'contextGraph'}
                        attributeIndex={i}
                        disabled
                      />
                    </div>
                  ))}
                </div>
              )}
            </div>
          ) : (
            <></>
          )}
        </div>
      )}
      {isSelected && (
        <EAButton
          onClick={(e) => {
            //history.push(`${ROUTES.CONTEXT_DETAIL_ADD_TP}?instance=${selectedContext.id}`)
            e.preventDefault();
            e.stopPropagation();
            addTp(node);
          }}
          content={
            <>
              <EAIcon icon={'context/addAssocier'} draggable={false} />
              <span style={{ marginLeft: '5px' }}>
                {i18next.t('addThirdparty.title')}
              </span>
            </>
          }
          customStyle={{
            position: 'relative',
            zIndex: 2,
            top: `${isSelected ? '-9px' : '-7px'}`,
            fontSize: '12px',
            height: '22px',
            minHeight: '0px',
            width: '128px',
            padding: '3px 5px',
          }}
          disabled={
            node.isContextArchived || node.isArchived ||
            !hasAnyOfPrivileges(PrivilegeEnum.PRIVILEGE_ADD_THIRDPARTY_CONTEXT)
          }
        />
      )}
    </div>
    <FormProvider {...methods}>
      <ArchiveDialog
        FORM_ID={FORM_ID}
        open={isArchiveOpen}
        onClose={() => setIsArchiveOpen(false)}
        callback={archiveTiersCallback}
        traductions={{
          title: i18next.t('context.popUpTiersArchiveTitle'),
          subTitle: i18next.t('context.popUpTiersArchiveSubTitle'),
          feedback: {
            title: i18next.t('context.contextTiersDeactivatedTitle'),
            message: i18next.t('context.contextTiersDeactivated'),
            tip: i18next.t('context.contextTiersDeactivatedTip')
          }
        }}
      />
    </FormProvider>
  </>);
};

export default NodeTemplate;
